import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { supabase } from './supabase';
import Dashboard from './Dashboard';
import Login from './Login';
import PurchaseForm from './PurchaseForm';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If the user clicked a password-reset email link, the URL hash will contain
    // type=recovery. In that case, ignore any session so the public /reset-password
    // route renders instead of bouncing the user to Dashboard.
    const inRecoveryFlow = typeof window !== 'undefined' &&
      window.location.hash.includes('type=recovery');

    // Check for existing session
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!inRecoveryFlow) {
        setUser(session?.user ?? null);
        if (session?.user) {
          checkIfAdmin(session.user.email);
        }
      }
      setLoading(false);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      // Don't treat a recovery session as a normal login.
      if (event === 'PASSWORD_RECOVERY') return;

      setUser(session?.user ?? null);
      if (session?.user) {
        checkIfAdmin(session.user.email);
      } else {
        setIsAdmin(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const checkIfAdmin = async (email) => {
    const { data } = await supabase
      .from('admin_users')
      .select('email')
      .eq('email', email)
      .single();
    setIsAdmin(!!data);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/purchase" element={<PurchaseForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={
          user ? <Dashboard user={user} isAdmin={isAdmin} /> : <Login />
        } />
      </Routes>
    </Router>
  );
}

export default App;